<template lang="pug">
  .cart-step
    validation-provider(:rules="{ required: { allowFalse: false } }")
      input.hidden(type="checkbox" :value="!!valid")

    .invalid.mb-8(v-if="!valid && pagination.items && pagination.items.length && !pagination.loading")
      .alert.warning
        p Einige Artikel scheinen nicht mehr verfügbar zu sein, oder haben sich verändert.
        p Bitte überprüfen Sie Ihre Bestellung.
    .relative
      Spinner(v-if="pagination.loading" :size="10" :thickness="2")
      ul(v-if="pagination.items && pagination.items.length")
        li.grid-labels
          .price-label Einzelpreis
          .qty-label Anzahl
          .sum-label Summe
        li.product(v-for="product in pagination.items")
          CartProductSummary(
            :key="product.id"
            :product="product"
            :cart-article-map="cartArticleMap"
            @refresh-cart="$emit('refresh-cart')"
          )
        //- li
          .price-label Einzelpreis
          .qty-label Anzahl
          .sum-label Summe
      Pagination(
        v-if="pagination.pageInfo && pagination.pageInfo.lastPage > 1"
        :last-page="pagination.pageInfo.lastPage"
        :current-page="pagination.pageInfo.currentPage"
        nav-class="pagination is-small is-rounded is-centered"
        @change="page => $emit('change-page', page)"
      )
        template(v-slot:prev)
          span.icon
            i.fas.fa-arrow-left
        template(v-slot:next)
          span.icon
            i.fas.fa-arrow-right
    BudgetingInfo
    .summary
      .summary-label.text-right.is-large Zusammenfassung
      template(v-if="customer && customer.show_net_prices && !customer.tax_free")
        .summary-label.text-right Netto
        .summary-value.text-right
          b {{ net | moneyFormat(currency) }}
      template(v-if="shippingFee")
        .summary-label.text-right Versandkosten
        .summary-value.text-right
          b {{ shippingFee | moneyFormat(currency) }}
      template(v-if="customer && customer.tax_free")
        .summary-label.text-right Gesamtsumme ({{ cart.qty }} St.)
        .summary-value.text-right
          b {{ net | moneyFormat(currency) }}
      template(v-else)
        //- .summary-label.text-right
        //-   span.add-space-after(v-if="!(customer && customer.show_net_prices && !customer.tax_free)") Enthaltene
        //-   | MwSt.
        //- .summary-value.text-right
        //-   b {{ cart.tax | moneyFormat(currency) }}
        .summary-label.text-right Gesamtsumme ({{ cart.qty }} St.)
        .summary-value.text-right
          b {{ cart.sum + shippingFee | moneyFormat(currency) }}
</template>

<script>
import { mapGetters } from 'vuex';

import { get } from '@/helpers';

import { ValidationProvider } from 'vee-validate';
import Pagination from '@/components/Pagination';
import CartProductSummary from '@/extensions/shop/components/CheckoutStepper/Steps/Partials/CartProductSummary';
import BudgetingInfo from '@/extensions/shop/components/BudgetingTool/info';

export default {
    name: 'CartStep',
    props: {
        pagination: {
            type: Object,
            required: true
        },
        sections: {
            type: Array,
            required: false
        }
    },
    components: {
        Pagination,
        CartProductSummary,
        ValidationProvider,
        BudgetingInfo
    },
    computed: {
        currency() {
            return (
                get(this.customer, 'customerGroup.currency.iso4217') ||
                get(this.defaultCustomerGroup, 'customerGroup.currency.iso4217') ||
                'EUR'
            );
        },
        net() {
            return this.cart.sum - this.cart.tax;
        },
        valid() {
            // check if every article is available and valid
            let valid = true;
            this.cart.articlePivots.forEach(el => {
                if (valid === false) return;
                if (!el.available || !el.valid) valid = false;
            });
            return valid;
        },
        cartArticleMap() {
            const articlePivots = get(this.cart, 'articlePivots') || [];

            let map = {};
            articlePivots.forEach(el => {
                if (!map[el.article.id]) map[el.article.id] = [];
                map[el.article.id].push(el);
            });

            // const map = articles.map(el => {
            //   let article = {};
            //   article[el.id] = el;
            //   return article;
            // });
            return map;
        },
        ...mapGetters({
            customer: 'shop/customer',
            defaultCustomerGroup: 'shop/defaultCustomerGroup',
            shippingFee: 'shop/shippingFee',
            checkout: 'shop/checkout',
            cart: 'shop/cart'
        })
    }
};
</script>

<style lang="sass" scoped>
@import "~@/assets/sass/variables"

.add-space-after:after
  content: ' '

.cart-step
  ul
    & > li.grid-labels
      display: none
    & > li.product
      @apply mb-6 pb-6
      // @apply px-3 py-2 bg-gray-200 rounded
      border-bottom: 2px solid theme('colors.gray.300')
  .summary
    @apply grid
    grid-template-rows: auto
    grid-template-columns: auto max-content
    grid-gap: 0.8rem
    grid-row-gap: 4px
    margin-top: 1rem
    margin-bottom: 0.6rem
    .summary-label
      grid-column: 1
      &.is-large
        @apply text-xl
        grid-column: 1 / 3
  .relative
    min-height: 100px

  @screen md
    ul, .summary
      @apply grid
      grid-template-rows: auto
      grid-template-columns: auto repeat(3, max-content)
      grid-gap: .8rem
      grid-row-gap: 4px

    .spinner-container
      // background: rgba(255, 255, 255, .5)
      background-color: rgba(238, 238, 241, 0.5)

      position: absolute
      width: 100%
      height: 100%
      z-index: 1

    ul
      & > li.grid-labels
        display: contents
      & > li.product + li.product::v-deep
        .cart-product-summary > .margin-top
          margin-top: 2rem
      ::v-deep
        .article-pivot
          display: contents
      .price-label
        @apply text-right
        grid-column-start: 2
      .qty-label
        @apply text-center
        grid-column-start: 3
      .sum-label
        @apply text-right
        grid-column-start: 4
      li, .cart-product-summary
        display: contents
      ::v-deep
        .info
          grid-column-start: 1
    .pagination-container
      margin-top: 2rem
    .summary
      grid-template-columns: auto max-content
      margin-top: 2rem
      margin-bottom: 2rem
      .summary-label
        grid-column: 1
        &.is-large
          @apply text-xl
          grid-column: 1 / 3
</style>
